import { tailwindVariants } from '@air/utils-tailwind';

export const workspaceAgentFormInput = tailwindVariants({
  base: 'w-full rounded-4 border border-gray-5 bg-gray-1 px-2 py-1 text-14 text-gray-12 outline-none placeholder:text-gray-9 focus-visible:border-altitude-9',
});

export const DESCRIBE_TEXT_MAX_LENGTH = 2000;
export const FIELD_VALUE_MAX_LENGTH = 120;
